import { render, staticRenderFns } from "./CollectorTable.vue?vue&type=template&id=ccbe9ae8&scoped=true&"
import script from "./CollectorTable.vue?vue&type=script&lang=js&"
export * from "./CollectorTable.vue?vue&type=script&lang=js&"
import style0 from "./CollectorTable.vue?vue&type=style&index=0&id=ccbe9ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbe9ae8",
  null
  
)

export default component.exports